import {Routes} from '@angular/router';
import {AppVersionComponent, VERSION_PATH} from '@npck/libs/ui-kit';
import {QR_ID} from './domain/query-param.keys';
import {Error} from './infra/app-error-handler.service';
import {emptyAuthSessionDataGuard, emptyConsentDataGuard} from './infra/guards/auth-guard.service';
import {AuthLayoutComponent} from './layout/auth/auth.layout.component';
import {BinComponent} from './pages/bin/bin.component';
import {CodeComponent} from './pages/code/code.component';
import {ConsentComponent} from './pages/consent/consent.component';
import {DocumentComponent} from './pages/document/document.component';
import {ErrorRedirectComponent} from './pages/error-redirect/error-redirect.component';
import {ErrorComponent} from './pages/error/error.component';
import {FinishComponent} from './pages/finish-page/finish.component';
import {IinComponent} from './pages/iin/iin.component';
import {LivenessDeviceComponent} from './pages/liveness-device/liveness-device.component';
import {OauthAuthorizeComponent} from './pages/oauth/oauth-authorize.component';
import {OauthComponent} from './pages/oauth/oauth.component';
import {LivenessQrComponent} from './pages/qr/liveness-qr/liveness-qr.component';
import {QrInfoComponent, QrInfoType} from './pages/qr/qr-info/qr-info.component';
import {ResetEsignComponent} from './pages/reset-esign/reset-esign.component';
import {RevokeEsignComponent} from './pages/revoke-esign/revoke-esign.component';
import {Path} from './path';

export const appRoutes: Routes = [
    {path: Path.ROOT, redirectTo: Path.NOT_FOUND, pathMatch: 'full'},
    {path: VERSION_PATH, component: AppVersionComponent},
    {path: Path.OAUTH, component: OauthComponent},
    {path: Path.OAUTH_AUTHORIZE, component: OauthAuthorizeComponent},
    {path: Path.ERROR, component: ErrorComponent, pathMatch: 'full'},
    {path: Path.NOT_FOUND, component: ErrorComponent, data: {error: Error.PAGE_NOT_FOUND}},
    {path: Path.DOCUMENT, component: DocumentComponent},
    {
        path: Path.ROOT, component: AuthLayoutComponent,
        children: [
            {path: Path.CODE, component: CodeComponent, canActivate: [emptyAuthSessionDataGuard]},
            {path: Path.IIN, component: IinComponent, canActivate: [emptyAuthSessionDataGuard]},
            {path: Path.BIN, component: BinComponent, canActivate: [emptyAuthSessionDataGuard]},
            {path: Path.LIVENESS, component: LivenessDeviceComponent, canActivate: [emptyAuthSessionDataGuard]},
            {path: Path.LIVENESS_QR + `/:${QR_ID}`, component: LivenessQrComponent},
            {path: Path.QR_WARNING + `/:${QR_ID}`, component: QrInfoComponent, data: {type: QrInfoType.WARNING}},
            {path: Path.LIVENESS_QR_SUCCEEDED + `/:${QR_ID}`, component: QrInfoComponent, data: {type: QrInfoType.SUCCEEDED}},
            {path: Path.OAUTH_CONSENT, component: ConsentComponent, canActivate: [emptyConsentDataGuard]},
            {path: Path.ERROR_REDIRECT, component: ErrorRedirectComponent},
            {path: Path.ESIGN_REVOCATION, component: RevokeEsignComponent},
            {path: Path.ESIGN_RESETTING, component: ResetEsignComponent},
            {path: Path.AUTH_FINISH, component: FinishComponent},
        ],
    },
    {path: '**', redirectTo: Path.NOT_FOUND},
];
